import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { NgxPaginationModule } from 'ngx-pagination'
import { SearchComponent } from '../../components/search/search.component'
import { UploadfileService } from '../../services/uploadfile/uploadfile.service'
import { catchError, map, Observable, of, tap } from 'rxjs'
import { FileGridComponent } from '../file-grid/file-grid.component'
import { FileAttach } from '../../models/files.interface'

@Component({
    selector: 'app-select-file',
    standalone: true,
    imports: [
        NgxPaginationModule,
        MatIcon,
        SearchComponent,
        CommonModule,
        FileGridComponent,
    ],
    templateUrl: './select-file.component.html',
    styleUrl: './select-file.component.css',
})
export class SelectFileComponent {
    public page = 1
    limit = 10
    total = 0
    selectedFile: File | null = null
    asyncFiles!: Observable<FileAttach[]>
    filesList: FileAttach[] = []

    constructor(
        private uploadService: UploadfileService,
        private dialogRef: MatDialogRef<SelectFileComponent>
    ) {}

    ngOnInit(): void {
        this.fetchFiles()
    }

    fetchFiles() {
        this.asyncFiles = this.uploadService.allFiles().pipe(
            tap((resp) => {
                this.filesList = resp.files
                this.total = resp.total
            }),
            map((resp) => resp.files),
            catchError((_err) => of([] as FileAttach[]))
        )
    }

    onChangeFile(event: Event): void {
        const input = event.target as HTMLInputElement
        if (input.files && input.files.length > 0) {
            const selectedFile = input.files[0]
            this.dialogRef.close(selectedFile)
        }
    }

    closeDialog() {
        this.dialogRef.close()
    }
}
